import { NextPage } from 'next';

import Layout from 'modules/layout';
import { getBasicStaticProps } from 'utils/page';
import ProAward2023Content from 'modules/static-pages/components/ProAward2023/ProAward2023Content';

const ProAward2023: NextPage = () => {
  const pageTitle = 'ゼヒトモプロアワード2023';
  const pageDescription =
    '2022年1月から12月の期間で、2つのカテゴリにおいて特に成果をあげた。事業者を表彰するアワードです。';

  return (
    <Layout
      language={'ja'}
      seo={{
        description: pageDescription,
        keywords: 'zehitomo, pro award, ゼヒトモ, プロアワード, 2023',
        ogDescription: pageDescription,
        ogImage:
          'https://res.cloudinary.com/zehitomo/image/upload/v1652747398/assets/openGraphLogo.png',
        ogTitle: pageTitle,
      }}
      title={pageTitle}
    >
      <ProAward2023Content />
    </Layout>
  );
};

export const getStaticProps = getBasicStaticProps(['pro-award-2023']);

export default ProAward2023;
